import i18n from 'i18n';

const RAW_CURRENCY_MAP = {
  JPY: 'JPY',
  HKD: 'HKD',
  SGD: 'SGD',
  CNY: 'CNY',
  AED: 'AED',
  EUR: 'EUR',
  USD: 'USD',
} as const;

export const CURRENCY_MAP = new Proxy(RAW_CURRENCY_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 CURRENCY_MAP！请直接通过属性精准获取值，如 CURRENCY_MAP.JPY',
    );
  },
});

export type CurrencyType =
  (typeof RAW_CURRENCY_MAP)[keyof typeof RAW_CURRENCY_MAP];

export const isCurrencySupported = (
  currency: string,
): currency is CurrencyType => {
  return Object.values(RAW_CURRENCY_MAP).includes(currency as CurrencyType);
};

export const CURRENCY_OPTION_LIST: {
  value: CurrencyType;
  label: string;
}[] = [
  { value: CURRENCY_MAP.JPY, label: i18n.t('jpy') },
  { value: CURRENCY_MAP.HKD, label: i18n.t('hkd') },
  { value: CURRENCY_MAP.SGD, label: i18n.t('sgd') },
  { value: CURRENCY_MAP.CNY, label: 'CNY' },
  { value: CURRENCY_MAP.AED, label: i18n.t('aed') },
  { value: CURRENCY_MAP.EUR, label: 'EUR' },
  { value: CURRENCY_MAP.USD, label: 'USD' },
];
